// 整改通知单
<template>
  <div class="projectFormLess" v-if="isComponentsShow">
    <!-- 第一行-项目名称 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_xiangm@2x.png" alt />
        <span>项目名称</span>
      </div>
      <div class="rightInput">
        <span class="isNotSubmitSpan">{{S_project_name}}</span>
      </div>
    </div>
    <!-- 第二行--通知人and通知时间 -->
    <div class="towRow" style="margin-bottom:35px">
      <div class="towRowBox">
        <div class="leftLabel">
          <img style="width:16px" src="../../assets/image/icon_zhmc@2x.png" alt />
          <span>通知人</span>
        </div>
        <div class="rightInput">
          <el-input :disabled="!isSubmit" v-model="addFormData.notifier"></el-input>
        </div>
      </div>
      <div class="towRowBox">
        <div class="leftLabel leftLabel2">
          <img style="width:17px" src="../../assets/image/icon_riqi@2x.png" alt />
          <span>通知时间</span>
        </div>
        <div class="rightInput">
          <el-date-picker
            :disabled="!isSubmit"
            v-model="addFormData.notice_time"
            type="date"
            :placeholder="isSubmit ? '选择日期' : ''"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </div>
      </div>
    </div>
    <!-- 第三行--现场情况记录 -->
    <div class="oneRow" style="margin-bottom:10px">
      <div class="leftLabel" style="width:100%;font-size:16px">
        <img style="width:17px" src="../../assets/image/icon_zhangg@2x.png" alt />
        <span
          style="width:calc(100% -30px); overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
          title="根据贵单位出具的整改意见，我公司项目组人员组织人员对贵公司现场进行了现场复查，整改情况如下"
        >我公司项目组人员对贵公司进行了现场勘查，现就需进行整改问题向贵单位通知如下:</span>
      </div>
    </div>
    <!-- 富文本 -->
    <div class="editUpdataBox ProjectTextAreaBox" style="width:100%" v-if="isSubmit">
      <el-input
        :disabled="!isSubmit"
        style="width:75%;min-width: 650px;"
        v-model="addFormData.existing_problems"
        :autosize="{minRows: 3}"
        type="textarea"
      ></el-input>
      <!-- <quill-editor
        ref="editQuillEditor"
        class="ql-editor"
        style="padding:0;margin-bottom:30px;width:75%"
        id="editdetailsquill"
        v-model="addFormData.existing_problems"
        :options="editorOptionedit"
      ></quill-editor>
      <el-upload
        class="avatar-uploader avatar-uploader-display"
        style="display:none;"
        action="#"
        ref="addUpLoad"
        :show-file-list="false"
        :before-upload="beforeAvatarUploadEdit"
      >
        <img v-if="addFormData.content" :src="addFormData.content" class="avatar" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>-->
    </div>
    <div v-else class="ql-container ql-snow" style="margin:20px 0">
      <div class="ql-editor" v-html="addFormData.existing_problems"></div>
    </div>
    <!-- 富文本 -->

    <!-- <div class="ProjectTextAreaBox" style="margin-bottom:50px;">
      <el-row class="addTItleBtnRow" style="margin-bottom:10px">
        <el-button @click="handleAddTM" v-if="isSubmit">添加条目</el-button>
      </el-row>
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :header-cell-style="{background:'#F4F5F6'}"
      >
        <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="standard" label="依据标准">
          <template slot-scope="scope">
            <span v-if="isSubmit" @click="tableClick(scope.row)">{{scope.row.standard}}</span>
            <span v-else>{{scope.row.standard}}</span>
          </template>
        </el-table-column>

        <el-table-column show-overflow-tooltip align="center" prop="problemImg" label="整改图片">
          <template slot-scope="scope">
            <div v-if="isSubmit" @click="tableClick(scope.row)">
              <img
                style="width:30px;height:30px;margin-right:1px"
                v-for="(item,index) in scope.row.problemImg.slice(0,3)"
                :src="item"
                alt
              />
            </div>
            <div v-else>
              <img
                @click="handleReceiverFlag1(item)"
                style="width:30px;height:30px;margin-right:1px"
                v-for="(item,index) in scope.row.problemImg.slice(0,3)"
                :src="item"
                alt
              />
            </div>
          </template>
        </el-table-column>

        <el-table-column show-overflow-tooltip align="center" prop="changeIdea" label="整改意见">
          <template slot-scope="scope">
            <span v-if="isSubmit" @click="tableClick(scope.row)">{{scope.row.changeIdea}}</span>
            <span v-else>{{scope.row.changeIdea}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="content" label="操作">
          <template slot-scope="scope">
            <span
              v-if="isSubmit"
              @click="removeUser(scope.$index,scope.row)"
              style="cursor: pointer;color:#128BF1"
            >删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>-->
    <!-- 签字 -->
    <!-- <div class="writeName" style="justify-content:flex-start;margin-bottom:25px">
      <img style="width:16px;margin-right:10px" src="../../assets/image/icon_qian@2x.png" alt />
      <span style="width:150px">企业接收人员签字</span>
      <img
        v-if="!addFormData.sign_receiving"
        @click="handleReceiverFlag1"
        style="width:66px;"
        src="../../assets/image/zaixianqianm@2x.png"
        alt
      />
      <img
        v-if="addFormData.sign_receiving"
        @click="handleReceiverFlag1(addFormData.sign_receiving)"
        style="width:66px;"
        :src="addFormData.sign_receiving"
        alt
      />
    </div>-->
    <!-- 第五行--上传附件 -->
    <div class="oneRow">
      <div class="leftLabel upLoadLabel">
        <img style="width:14px" src="../../assets/image/icon_fj@2x.png" alt />
        <span>上传附件</span>
      </div>
      <div class="rightInput">
        <upload-file
          :isSubmit="isSubmit"
          :imgList="this.addFormData.annex"
          :detailsImgList="detailsImgList"
          @my-upload-change="upLoadChange"
        ></upload-file>
      </div>
    </div>
    <div class="oneRow" style="margin-bottom:30px">
      <div class="leftLabel"></div>
      <div class="rightInput" style="display:flex;align-items:center">
        <div style="color:rgb(245, 95, 95);font-size:14px;">*请上传整改通知单,模板文件：</div>
        <a style="font-size:14px;" href="http://control.sxpz.vip/Template/整改通知单.doc">整改通知单.doc</a>
      </div>
    </div>

    <!-- 审批备注 -->
    <div class="oneRow" style="margin-bottom:35px;margin-top:20px" v-if="addFormData.is_approve==1">
      <div class="leftLabel">
        <img style="width:17px" src="../../assets/image/icom_jj@2x.png" alt />
        <span>审批备注</span>
      </div>
      <div class="rightInput">
        <el-input v-model="approval_remark"></el-input>
      </div>
    </div>

    <!-- 按钮行 -->
    <div class="btnRow">
      <el-button @click="handleSubmit('1')" v-if="addFormData.is_edit!='1'">保存草稿</el-button>
      <el-button
        v-if="addFormData.withdraw_status=='1'"
        @click="handleProjectWithDraw"
        style="background-color:rgb(255, 26, 26);"
      >撤回</el-button>
      <el-button
        style="background-color:#40A0F2"
        @click="handleSubmit('0')"
        v-if="addFormData.is_edit!='1'"
      >提交</el-button>
      <el-button
        v-if="addFormData.is_approve==1"
        @click="handleExamine('-1')"
        style="background-color:#f4a029"
      >驳回</el-button>
      <el-button
        v-if="addFormData.is_approve==1"
        @click="handleExamine('1')"
        style="background-color:#40A0F2"
      >审批通过</el-button>
    </div>
    <!-- 按钮行 -->
    <!-- 签名组件 -->
    <sign-dialog
      @wirtDoen="handleWriteDone1"
      :visible.sync="receiverSignFlag1"
      @change="handleReceiverSign"
    ></sign-dialog>
    <!-- 签名组件 -->
    <!-- 整改通知单-添加弹窗 -->
    <el-dialog
      :visible.sync="dialogVisibleAdd"
      width="50%"
      class="addUserDia"
      :before-close="handleCloseAdd"
      :modal-append-to-body="false"
      @close="handleClosedAdd"
    >
      <div slot="title" class="header-title">
        <span class="title-age">添加条目</span>
      </div>
      <div class="diaContainer">
        <el-form ref="form" :model="AddUserForm" label-width="30%">
          <el-form-item label="依据标准">
            <el-input :placeholder="isSubmit ? '请输入依据标准' : ''" v-model="AddUserForm.standard"></el-input>
          </el-form-item>
          <el-form-item label="问题点图片">
            <upload-img
              :imgList="AddUserForm.problemImg"
              @my-img-change="imgChange1"
              style="width:80%"
            ></upload-img>
          </el-form-item>
          <el-form-item label="整改意见">
            <el-input :placeholder="isSubmit ? '请输入整改意见' : ''" v-model="AddUserForm.changeIdea"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button style="background-color: #ccc;" @click="dialogVisibleAdd = false">取 消</el-button>
        <el-button type="primary" v-if="diaFormType=='add'" @click="handleAddUser">添 加</el-button>
        <el-button type="primary" v-if="diaFormType=='edit'" @click="editUserForm">修 改</el-button>
      </div>
    </el-dialog>

    <!-- 查看进度 -->
    <project-flow
      v-if="this.addFormData.approval_log && this.addFormData.approval_log.length>0"
      :projectFlowLog="this.addFormData.approval_log"
      :projectName="this.addFormData.project_name"
      :companyName="this.addFormData.company_name"
      :projectId="this.addFormData.project_id"
      :stageCode="'22'"
    ></project-flow>
    <go-finance
      v-if="this.addFormData.approval_log && this.addFormData.approval_log.length>0"
      :projectId="this.addFormData.project_id"
    ></go-finance>

    <!-- 签名详情弹窗 -->
    <el-dialog
      :visible.sync="showDetailsDia"
      width="50%"
      class="addUserDia imgDetailsDia"
      :before-close="showDetailsDiaClose"
    >
      <div class="diaContainer">
        <img :src="showDetailsSign" alt />
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 引入富文本相关 start
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import * as Quill from 'quill'
//quill编辑器的字体
var fonts = [
  'SimSun',
  'SimHei',
  'Microsoft-YaHei',
  'KaiTi',
  'FangSong',
  'Arial',
  'Times-New-Roman',
  'sans-serif',
]
var Font = Quill.import('formats/font')
Font.whitelist = fonts //将字体加入到白名单
Quill.register(Font, true)
//图片缩放
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageResize', ImageResize)
// 工具栏配置
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'], // toggled buttons
  ['blockquote', 'code-block'],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
  [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
  [{ direction: 'rtl' }], // text direction

  [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ['link', 'image', 'video'],
  ['clean'], // remove formatting button
]
const toolbarOptions1 = [
  [], // toggled buttons
  [],

  [], // custom button values
  [],
  [], // superscript/subscript
  [], // outdent/indent
  [], // text direction

  [], // custom dropdown
  [],

  [], // dropdown with defaults from theme
  [],
  [],
  [],
  [], // remove formatting button
]
// 引入富文本相关 end
import ProjectFlow from '../ProjectFlow'
import GoFinance from '../GoFinance'
import SignDialog from '../SignDialog'
import UploadFile from '../UploadFile'
import UploadImg from '../UploadImg'
export default {
  data() {
    return {
      tiemID: null,
      timeDou: 100,
      showDetailsSign: '',
      showDetailsDia: false,

      S_project_name: '',
      approval_remark: '',
      isSubmit: true,
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      details_project_id: '',
      details_project_status: '',
      // 表格
      editTableIndex: '',
      diaFormType: 'add',
      // 表格
      isSubmit: true,
      detailsImgList: [],
      submitImgList: [],

      addFormData: {
        annex: '',
        notifier: '',
        notice_time: '',
        existing_problems: '',
        sign_receiving: '',
      },
      AddUserForm: {
        problemImg: [],
        changeIdea: '',
        standard: '',
      },
      dialogVisibleAdd: false,
      // 签名
      receiverSignFlag1: false,
      receiverSignFlag2: false,
      writeDoneImg1: '',
      writeDoneImg2: '',
      // 签名
      topBarActive: '1',
      infop: '',
      member_id: '',
      token: '',
      value: '',
      tableData: [],
      // 富文本
      editorOptionedit1: {
        modules: {
          toolbar: {
            container: toolbarOptions1, // 工具栏
          },
        },
      },
      editorOptionedit: {
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function (value) {
                if (value) {
                  // alert('自定义图片')
                  // 调用element图片上传
                  document
                    .querySelector('.editUpdataBox .avatar-uploader-icon')
                    .click()
                } else {
                  this.quill.format('image', false)
                }
              },
            },
          },
          imageResize: {}, // 配置图片可缩放大小
        },
      },
      // 富文本
      isComponentsShow: false,
    }
  },
  methods: {
    // *撤回项目
    async handleProjectWithDraw() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)

        param.append('project_id', this.details_project_id)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/withdraw',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getProjectDetails()
      }, this.timeDou)
    },
    selectPermitChange() {
      if (this.addFormData.permit_type == '1') {
        this.addFormData.permit_type_sub = ''
      }
      if (this.addFormData.permit_type == '2') {
        this.addFormData.permit_type_sub = '1'
      }
    },
    // 富文本上传
    async beforeAvatarUploadEdit(file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2
      let param = new FormData()
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('member_id', this.member_id)
      param.append('file', file)
      // return console.log('param', param.get('access_token'))
      const { data: res } = await this.$axios({
        method: 'post',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        url: '/api/User/uploadImg',
        // data: param,
        data: param,
      })
      // return console.log('res', res)
      if (res.code != 200) return this.$message.error(res.datas.msg)

      let quill = this.$refs.editQuillEditor.quill
      // 如果上传成功
      if (res) {
        // 获取光标所在位置
        let length = quill.getSelection().index
        // 插入图片，res为服务器返回的图片链接地址
        quill.insertEmbed(length, 'image', res.datas.img_url)
        // 调整光标到最后
        quill.setSelection(length + 1)
      } else {
        // 提示信息，需引入Message
        this.$message.error('图片插入失败')
      }
      console.log('asdasdasdas')
      return new Promise((resolve, reject) => {
        this.$refs['addUpLoad'].validate((valid) => {
          if (valid) {
            return resolve(true)
          } else {
            return reject(false)
          }
        })
      })
    },
    // *审批提交
    async handleExamine(val) {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('approval_status', val)
        param.append('remark', this.approval_remark)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/rectify_approval',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails()
      }, this.timeDou)
    },
    // *编辑提交
    async handleSubmit(val) {
      // this.addFormData.existing_problems = JSON.stringify(this.tableData)
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('is_draft', val)
        param.append('notifier', this.addFormData.notifier)
        param.append('notice_time', this.addFormData.notice_time)
        param.append('existing_problems', this.addFormData.existing_problems)
        // param.append('sign_receiving', this.addFormData.sign_receiving)

        param.append('annex', JSON.stringify(this.submitImgList))

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/rectify',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails()
      }, this.timeDou)
    },
    // *获取详情
    async getProjectDetails() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.details_project_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/rectify_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      // 判断是不是首次到此流程
      if (res.datas.info.is_new != 1) {
        this.addFormData = res.datas.info
      }
      // 判断禁用
      if (this.addFormData.is_draft != '1' && this.addFormData.is_edit == '1') {
        this.isSubmit = false
      } else {
        this.isSubmit = true
      }
      // 项目名称
      this.S_project_name = res.datas.info.project_name
      // 判断表格
      // if (this.addFormData.existing_problems) {
      //   // this.tableData = this.addFormData.existing_problems
      //   this.addFormData.existing_problems = '123'
      // }
      // 判断文件上传
      if (this.addFormData.annex) {
        this.detailsImgList = this.addFormData.annex
        this.submitImgList = this.addFormData.annex
      }
      // 判断签名
      // if (this.addFormData.sign_receiving == 'undefined') {
      //   this.addFormData.sign_receiving = ''
      // }
      this.isComponentsShow = true
      console.log('整改通知单-详情', this.addFormData)
    },
    // 表格相关
    removeUser(index, row) {
      this.tableData.splice(index, 1)
      console.log(this.tableData)
    },
    handleAddTM() {
      this.diaFormType = 'add'
      this.dialogVisibleAdd = true
    },
    tableClick(row, column, event) {
      this.diaFormType = 'edit'
      this.editTableIndex = this.tableData.findIndex(
        (item) => item.id == row.id
      )
      this.AddUserForm = row
      console.log('点击了哪一行', this.AddUserForm)
      this.dialogVisibleAdd = true
    },
    editUserForm() {
      this.tableData[this.editTableIndex] = this.AddUserForm
      this.dialogVisibleAdd = false
    },
    handleAddUser() {
      this.tableData.push({
        id: new Date().getTime(),
        problemImg: this.AddUserForm.problemImg,
        changeIdea: this.AddUserForm.changeIdea,
        standard: this.AddUserForm.standard,
      })
      this.dialogVisibleAdd = false
    },
    // 表格相关

    // 弹窗上传图片1
    imgChange1(data) {
      this.AddUserForm.problemImg = data
    },
    imgChange2(data) {
      this.AddUserForm.changeImg = data
    },
    // 弹窗上传图片

    // 签名
    handleWriteDone1(data) {
      this.addFormData.sign_receiving = data
    },

    handleReceiverFlag1(url) {
      if (!this.isSubmit) {
        if (url) {
          this.showDetailsSign = url
          this.showDetailsDia = true
        }
        return
      }

      this.receiverSignFlag1 = true
    },
    handleReceiverSign() {},
    // 签名
    handleChange() {},
    handleTopBarClikc(val) {
      this.topBarActive = val
    },
    upLoadChange(data) {
      console.log('文件列表', data)
      this.submitImgList = data
    },
    handleCloseAdd() {
      this.dialogVisibleAdd = false
    },
    handleClosedAdd() {
      this.AddUserForm = {
        problemImg: [],
        changeIdea: '',
        standard: '',
      }
      this.diaFormType = 'add'
      this.editTableIndex = ''
    },
    showDetailsDiaClose() {
      this.showDetailsDia = false
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.details_project_id = this.$route.query.project_id || ''
    this.details_project_status = this.$route.query.project_status || ''
    if (this.details_project_status && this.details_project_id) {
      this.getProjectDetails()
    }
  },
  components: {
    SignDialog,
    UploadFile,
    UploadImg,
    ProjectFlow,
    GoFinance,
  },
}
</script>
<style lang="less" scoped>
@import url(../project/projectForm.less);
</style>